<div style="display: flex; width: 100%; height: 100vh; overflow: hidden;">
    <app-home-metrics style="flex: 0 0 70%;"></app-home-metrics>
    <app-home-tabs-nav style="flex: 0 0 30%;"></app-home-tabs-nav>
</div>
